import { Component, Mixins } from 'vue-property-decorator';
import StudioModal from '@/components/modals/StudioModal.vue';
import ProjectContainerMixin from '../ProjectContainerMixin';
import { EModalName } from '@/helpers/modal';

@Component({
  components: {
    StudioModal,
  },
})
export default class CreateEditProjectModalMixin extends Mixins(ProjectContainerMixin) {
  get modalName(): string {
    return EModalName.createEditProject;
  }

  get title(): string {
    if (this.projectToEdit) return `Edit ${this.projectToEdit.title}`;

    return 'Create a scene collection';
  }

  beforeOpen() {
    if (this.projectToEdit) {
      this.projectName = this.projectToEdit.title;
      this.resolution = this.allowedStreamResolutions.find(resolution => resolution.value === this.projectToEdit.settings.resolution).label;
    }
  }
}
